import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { contactApi } from "../api";

export default function Footer() {
  const { language, pathFor, t } = useLanguage();
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (event) => {
    event.preventDefault();
    setState("loading");
    try {
      await contactApi.newsletter(email, language);
      setEmail("");
      setState("success");
    } catch {
      setState("error");
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-grid container-wide">
        <div>
          <p className="footer-heading">Eco Bambù</p>
          <Link to={pathFor("/about/")}>{t("about")}</Link>
          <Link to={pathFor("/howtoorder/")}>{t("howToOrder")}</Link>
          <Link to={pathFor("/contact/")}>{t("contact")}</Link>
        </div>
        <div>
          <p className="footer-heading">{t("legal")}</p>
          <Link to={pathFor("/privacy-policy/")}>{t("privacy")}</Link>
          <Link to={pathFor("/cookie-policy/")}>{t("cookies")}</Link>
          <Link to={pathFor("/terms-and-conditions/")}>{t("terms")}</Link>
        </div>
        <div className="newsletter-block">
          <p className="footer-heading">{t("newsletter")}</p>
          <p>{t("newsletterCopy")}</p>
          <form className="newsletter-form" onSubmit={submit}>
            <label className="sr-only" htmlFor="newsletter-email">{t("email")}</label>
            <input
              id="newsletter-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder={t("email")}
              required
            />
            <button disabled={state === "loading"}>{t("subscribe")}</button>
          </form>
          <p className="form-status" aria-live="polite">
            {state === "success" && t("subscribed")}
            {state === "error" && "Please try again."}
          </p>
        </div>
      </div>
      <div className="footer-bottom container-wide">
        <span>© {new Date().getFullYear()} Eco Bambù s.r.l. semplificata</span>
        <span>VAT IT 02506600978 · Prato, Italy</span>
      </div>
    </footer>
  );
}
